const BREAK_POINTS = {
    xs: '480px',
    sm: '576px',
    md: '768px',
    lg: '1024px',
    xl: '1440px',
    xxl: '1600px',
};
const GRID_COLUMNS = 12;

export { BREAK_POINTS, GRID_COLUMNS };
